import { styled } from '@mui/system';
import Box from '@mui/system/Box';
import { ReactNode } from 'react';

export const HeaderAdvancedFilters = styled(Box)`
  display: grid;
  gap: 16px;

  @media (min-width: 620px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media (min-width: 1200px) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  @media (min-width: 1500px) {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
`;

interface HeaderAdvancedFiltersOptionType {
  className?: string;
  key?: string;
  children: ReactNode;
}

export const AdvancedFilterOption: React.FC<HeaderAdvancedFiltersOptionType> = ({
  className,
  children,
}) => (
  <Box
    className={className}
    sx={{
      border: '1px solid',
      borderColor: 'primary.main',
      width: '100%',
      borderRadius: '8px',
      position: 'relative',
      backgroundColor: 'tertiary.main',

      '& .dropdown-container': {
        borderRadius: '0 !important',
        border: 'none !important',
      },

      '& .multi-select': {
        borderRadius: '0 0 8px 8px !important',
        overflow: 'hidden',
      },

      '& .dropdown-heading-dropdown-arrow': {
        display: 'none',
      },

      '& .dropdown-content': {
        paddingTop: '0',
      },

      '& .dropdown-content, & .panel-content': {
        borderRadius: '0 !important',
        boxShadow: 'none !important',
      },

      '& .MuiPaper-root': {
        boxShadow: 'none',

        '& .MuiButtonBase-root': {
          padding: '2px 16px',
          minHeight: 'unset',
          border: '1px solid',
          borderColor: 'primary.main',
          color: 'primary.main',
          backgroundColor: 'secondary.main',
          borderRadius: '40px',
        },

        '& .MuiCollapse-root': {
          position: 'absolute',
          backgroundColor: 'tertiary.main',
          left: '-16px',
          boxShadow: 'none',
        },

        '& .MuiAccordionSummary-content': {
          margin: '0',

          '& label': {
            fontSize: '14px !important',
          },
        },

        '& .count_item': {
          top: '0',
          right: '0',
        },
      },
    }}
  >
    {children}
  </Box>
);
